/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Placeholder_TopicInputs */

const en_us2_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your question`)
};

const pt_br2_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua pergunta`)
};

const es_419_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu pregunta`)
};

const pt_pt2_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua pergunta`)
};

const fr_fr2_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta question`)
};

const de_de2_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Frage`)
};

const it_it2_coach_placeholder_topic = /** @type {(inputs: Coach_Placeholder_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua domanda`)
};

/**
* | output |
* | --- |
* | "Your question" |
*
* @param {Coach_Placeholder_TopicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_placeholder_topic = /** @type {((inputs?: Coach_Placeholder_TopicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Placeholder_TopicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_placeholder_topic(inputs)
	if (locale === "es-419") return es_419_coach_placeholder_topic(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_placeholder_topic(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_placeholder_topic(inputs)
	if (locale === "de-DE") return de_de2_coach_placeholder_topic(inputs)
	if (locale === "it-IT") return it_it2_coach_placeholder_topic(inputs)
	return en_us2_coach_placeholder_topic(inputs)
});
export { coach_placeholder_topic as "coach.placeholder_topic" }